
function TimeReportIcon() {
	return (
		<svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<g
				fill="#FFFFFF"
				stroke="#FFFFFF"
				strokeLinecap="square"
				strokeLinejoin="miter"
				strokeMiterlimit="10"
				strokeWidth="2"
			>
				<line fill="none" strokeLinecap="butt" x1="12" x2="12" y1="1" y2="5" />
				<line fill="none" strokeLinecap="butt" x1="23" x2="19" y1="12" y2="12" />
				<line fill="none" strokeLinecap="butt" x1="12" x2="12" y1="23" y2="19" />
				<line fill="none" strokeLinecap="butt" x1="1" x2="5" y1="12" y2="12" />
				<circle cx="12" cy="12" fill="none" r="11" stroke="#FFFFFF" />
				<polyline fill="none" points=" 8,6 12,12 16,12 " />
			</g>
		</svg>
	);
}

export default TimeReportIcon;
